import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PaymentMethod } from './types';

export type Response = PaymentMethod;

export default (makeCall: MakeCall) =>
  (uuid: string, confirmationToken: string) =>
    makeCall<Response>('PUT', `/api/v2/payment/method/pay-in/${uuid}`, {
      data: { token1: confirmationToken },
    });
